import { render, staticRenderFns } from "./UploadRequestResultsTable.vue?vue&type=template&id=1752979a&scoped=true"
import script from "./UploadRequestResultsTable.vue?vue&type=script&lang=js"
export * from "./UploadRequestResultsTable.vue?vue&type=script&lang=js"
import style0 from "./UploadRequestResultsTable.vue?vue&type=style&index=0&id=1752979a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1752979a",
  null
  
)

export default component.exports